import { TableCollectionActionVisibility } from '../types/table-collection-action-visibility';
import { TableCollectionActionDisability } from '../types/table-collection-action-disability';
import { TableCollectionActionCommand } from '../types/table-collection-action-command';

export class TableCollectionAction<Item, Filter, Action> {
  public constructor(
    public readonly key: Action,
    public readonly label: string,
    public readonly visibility: TableCollectionActionVisibility<Item, Filter>,
    public readonly disability: TableCollectionActionDisability<Item, Filter>,
    public readonly command: TableCollectionActionCommand<Item, Filter>,
  ) {}
}
